import React from "react";
import heroSectionTechnology from "./images/hero-section-technology-img1.webp";
import "./style.css";
import aaImage from "../pages/images/aa.webp";

function AccountAggregatorNetwork() {
  return (
    <div>
      <div className="main wrapper">
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionTechnology} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>ACCOUNT AGGREGATOR NETWORK</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** ACCOUNT AGGREGATOR NETWORK SECTION STARTS *************** --> */}
        <div class="aa-section introduction">
          <p style={{ lineHeight: 1.6 }}>
            Applying for a loan or financial product is now easier with the{" "}
            <strong>Account Aggregator Network</strong>. This secure system
            enables seamless digital data sharing,{" "}
            <strong>while keeping you in complete control</strong>. You decide
            what to share, with whom, and for how long.
          </p>
        </div>

        <div class="aa-section what-is-aa">
          <h2>What is an Account Aggregator?</h2>
          <ul style={{ lineHeight: 1.6 }}>
            <li>
              <strong>Account Aggregator (AA)</strong> is an{" "}
              <strong>RBI-regulated</strong> entity that enables secure and
              seamless sharing of financial data between institutions.
            </li>
            <li>
              Your <strong>explicit consent</strong> is required before any data
              is shared. You are clearly informed about the{" "}
              <strong>terms, purpose, and reasons</strong> to ensure complete
              transparency.
            </li>
            <li>
              The process is <strong>entirely digital</strong> and takes place
              in <strong>near real-time</strong>, ensuring both{" "}
              <strong>efficiency and security</strong>.
            </li>
            <li>
              <strong>
                Account Aggregators cannot read or store your data
              </strong>
              . They act purely as a secure bridge, keeping your financial
              information protected at all times.
            </li>
            <li>
              With <strong>Account Aggregators, you remain in control</strong> —
              deciding{" "}
              <strong>what to share, with whom, and for how long</strong>.
            </li>
          </ul>
        </div>

        <div class="aa-section how-aa-works">
          <h2>How the AA Network Works?</h2>
          <ul style={{ lineHeight: 1.6 }}>
            <li>
              Register with an Account Aggregator (AA) through their app or
              website.
            </li>
            <li>Select the bank account(s) you want to link.</li>
            <li>
              When applying for a loan, the AA requests your consent to share
              data via OTP verification.
            </li>
            <li>
              Choose the specific data to be shared and define the duration for
              which it will be accessible.
            </li>
            <li>
              Once the bank receives the data, it evaluates your profile and
              processes your loan application.
            </li>
            <li>You can revoke your consent at any time.</li>
          </ul>
        </div>

        <div class="aa-image-container">
          <img src={aaImage} alt="Account Aggregator Illustration" />
        </div>

        <div class="aa-section benefits">
          <h2>Benefits of the AA Network</h2>
          <ul style={{ lineHeight: 1.6 }}>
            <li>
              Customers decide what data to share, with whom to share it, and
              for how long.
            </li>
            <li>
              The entire process is fully digital and takes place instantly.
            </li>
            <li>
              Account Aggregators do not store customer data, making the system
              highly secure.
            </li>
            <li>
              No need to manually upload account statements or grant full access
              to your bank account when applying for a loan.
            </li>
          </ul>
        </div>

        <div class="aa-section data-safety">
          <h2>How Safe Is My Data with the AA?</h2>
          <p style={{ lineHeight: 1.6 }}>
            <strong>Account Aggregators (AAs) act as secure messengers</strong>,
            not data storage entities. They{" "}
            <strong>do not retain or alter</strong> your financial data.
            Instead, they{" "}
            <strong>enable seamless, consent-driven sharing</strong> between
            your bank and the financial institution requesting the information.{" "}
            <strong>Your data always remains with your bank</strong>, ensuring
            maximum privacy and security.
          </p>
        </div>

        <div class="aa-section registration-info">
          <h2>Do I Need to Register with All AAs?</h2>
          <p style={{ lineHeight: 1.6 }}>
            Not necessarily!{" "}
            <strong>
              Registering with a single Account Aggregator (AA) is sufficient
            </strong>{" "}
            to access financial data sharing. However, if you prefer more
            flexibility or have varied financial needs, you're free to register
            with multiple AAs — the choice is entirely yours.
          </p>
        </div>

        <div class="aa-section grievance">
          <h2>Grievance Redressal</h2>
          <p style={{ lineHeight: 1.6 }}>
            Our grievance resolution process is managed by the{" "}
            <strong>SVCL Team</strong>, and we are committed to addressing your
            queries and concerns as quickly and efficiently as possible. You can
            read more about our grievance redressal policy at{" "}
            <a href="/grievance">Click Here</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AccountAggregatorNetwork;
